module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"tabLabels":{"read":"Les","memorize":"Memo","quiz":"Quiz","memorize2":"Memo","quiz2":"Quiz","overview":"Memo"}},"en":{"tabLabels":{"read":"Read","memorize":"Memo","quiz":"Quiz","memorize2":"Memo","quiz2":"Quiz","overview":"Memo"}}}')
  delete Component.options._Ctor
}
